import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { LogOut, LayoutDashboard, Home } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function AppNav() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  if (!user) return null;

  const isKid = !!user.kid_locked_to;

  const goHome = () => {
    if (isKid) {
      nav(`/students/${user.kid_locked_to}/home`);
      return;
    }
    if (loc.pathname === "/dashboard") return;
    nav("/dashboard");
  };

  return (
    <header
      className="w-full border-b-2 sticky top-0 z-30"
      style={{ borderColor: "var(--tm-border)", backgroundColor: "#ffffff" }}
      data-testid="app-nav"
    >
      <div className="mx-auto max-w-6xl px-4 sm:px-6 py-3 flex items-center justify-between gap-3">
        <button
          onClick={goHome}
          className="tm-btn tm-btn-ghost px-2"
          data-testid="nav-home-btn"
          aria-label="Home"
        >
          <span
            aria-hidden
            style={{
              display: "inline-block",
              width: 32,
              height: 32,
              borderRadius: 8,
              background: "var(--tm-brand)",
              color: "#fff",
              lineHeight: "32px",
              textAlign: "center",
              fontFamily: "Nunito, sans-serif",
              fontWeight: 900,
            }}
          >
            T
          </span>
          <span className="text-lg font-extrabold" style={{ fontFamily: "Nunito, sans-serif" }}>
            ThinkMyWay
          </span>
        </button>
        <div className="flex items-center gap-2">
          {!isKid && (
            <Link to="/dashboard" className="tm-btn tm-btn-ghost" data-testid="nav-dashboard-link">
              <LayoutDashboard size={18} />
              <span className="hidden sm:inline">Dashboard</span>
            </Link>
          )}
          <button onClick={logout} className="tm-btn tm-btn-outline" data-testid="nav-logout-btn">
            <LogOut size={18} />
            <span className="hidden sm:inline">Sign out</span>
          </button>
        </div>
      </div>
    </header>
  );
}
